import { useAuth } from "../context/AuthContext";
import { wishlistService } from "../services/wishlistService";
// import { affiliateService } from "../services/affiliateService"; // COMMENTED: Affiliate functionality disabled
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import DealTimer from "./DealTimer";
import { useTheme } from "../context/ThemeContext";
import PreviewableImage from "../components/PreviewableImage";
import "./ProductCard.css";

export default function ProductCard({ product, showAffiliateInfo = false, isAffiliate = false }) {
  // COMMENTED: Login requirement disabled for regular users
  // const { user } = useAuth();
  const navigate = useNavigate();
  const { darkMode } = useTheme();

  const [liked, setLiked] = useState(false);
  const [loading, setLoading] = useState(false);

  // Generate a simple user ID for localStorage if not logged in
  const getUserId = () => {
    let userId = localStorage.getItem("anonymous_user_id");
    if (!userId) {
      userId = "user_" + Date.now();
      localStorage.setItem("anonymous_user_id", userId);
    }
    return userId;
  };

  const uid = getUserId();

  // Check if product is in wishlist when component mounts
  useEffect(() => {
    if (product?.id) {
      checkWishlistStatus();
    }
  }, [product?.id]);

  const checkWishlistStatus = async () => {
    try {
      // LocalStorage-only check (no backend call)
      const wishlist = await wishlistService.getWishlist(uid);
      const exists = wishlist.some((item) => item.productId === product.id);
      setLiked(exists);
    } catch (error) {
      setLiked(false);
    }
  };

  const handleWishlistToggle = async () => {
    if (loading) return;

    setLoading(true);

    try {
      if (liked) {
        const result = await wishlistService.removeFromWishlist(uid, product.id);
        setLiked(false);
      } else {
        const result = await wishlistService.addToWishlist(uid, product.id);
        setLiked(true);
      }

      window.dispatchEvent(new Event("wishlist-updated"));
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      setLiked(!liked);

      if (
        error.message === "Failed to add to wishlist" ||
        error.message === "Failed to remove from wishlist"
      ) {
        alert("Failed to update wishlist. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`product-card ${darkMode ? "dark" : ""}`}>
      <div className="image-wrap">
        <button
          className={`wishlist-btn ${liked ? "active" : ""} ${loading ? "loading" : ""}`}
          onClick={handleWishlistToggle}
          disabled={loading}
        >
          {loading ? (
            <span className="loading-spinner">...</span>
          ) : (
            <svg
              className="heart-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill={liked ? "currentColor" : "none"}
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
          )}
        </button>

        <PreviewableImage src={product.image} alt={product.name} />

        <span className={`platform-badge ${product.platform.toLowerCase()}`}>
          {product.platform}
        </span>

        {product.dealEndTime && (
          <div className="deal-badge">
            <span>Deal</span>
            <DealTimer endTime={product.dealEndTime} />
          </div>
        )}
      </div>

      <div className="card-body">
        <h3 className="title">{product.title}</h3>

        <div className="meta">
          <span className="price">{product.price}</span>

          {product.dealTag && (
            <span className={`deal-tag ${product.dealTag.toLowerCase()}`}>
              {product.dealTag}
            </span>
          )}
        </div>

        <button
          className="buy-btn"
          onClick={(e) => {
            e.preventDefault();

            if (product.affiliateLink) {
              window.open(product.affiliateLink, "_blank");
            } else if (product.link) {
              window.open(product.link, "_blank");
            } else {
              console.error("No link available for product:", product);
            }
          }}
        >
          Buy Now
        </button>
      </div>
    </div>
  );
}